import React from "react";
import "./DiagnosisTable.css";

const DiagnosisTable = ({ selectedPatient }) => {
  console.log(selectedPatient, "selectedPatient");

  return (
    <div className="diagnosis-table-container">
      <p>Diagnostic List</p>
      <table className="diagnosis-table">
        <thead>
          <tr>
            <th>Diagnosis</th>
            <th>Description</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {selectedPatient?.diagnostic_list?.length > 0 ? (
            selectedPatient.diagnostic_list.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>{item.description}</td>
                <td className={`status ${item.status.toLowerCase()}`}>
                  {item.status}
                </td>
              </tr>
            ))
          ) : (
            <p>No diagnostics available for this patient.</p>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DiagnosisTable;
